export const TID = {
    nav: {
        wrapper: "main-nav",
        home: "nav-home-link",
        journey: "nav-journey-link",
        building: "nav-building-link",
        labs: "nav-labs-link",
        alati: "nav-alati-link",
        music: "nav-music-link",
        journal: "nav-journal-link",
        media: "nav-media-link",
        contact: "nav-contact-link",
        mobileToggle: "nav-mobile-toggle",
        mobileMenu: "nav-mobile-menu",
        brand: "nav-brand",
    },
    home: {
        heroBegin: "hero-begin-journey-btn",
        heroBuilding: "hero-see-building-btn",
        labsCta: "pathway-labs-cta",
        alatiCta: "pathway-alati-cta",
        musicCta: "pathway-music-cta",
        followJourney: "follow-journey-cta",
        signupForm: "hero-email-signup",
        signupFirstName: "signup-firstname",
        signupEmail: "signup-email",
        signupSubmit: "signup-submit",
        signupSuccess: "signup-success",
        signupError: "signup-error",
    },
    contact: {
        form: "contact-form",
        name: "contact-name",
        email: "contact-email",
        org: "contact-org",
        type: "contact-type",
        message: "contact-message",
        consent: "contact-consent",
        submit: "contact-form-submit",
        success: "contact-success",
        error: "contact-error",
    },
    journal: {
        list: "journal-list",
        card: "journal-card",
        categoryFilter: "journal-category-filter",
    },
    footer: {
        wrapper: "site-footer",
        signup: "footer-signup-form",
    },
};
